module.exports = __webpack_public_path__ + "static/media/weather.61f4933b.png";